import Card from "../card/Card";
import BodyText from "../support/BodyText";
import HeadingText from "../support/HeadingText";
import styles from "./AuthProfileSelectionModal.module.scss";
import ProfileSelectionButton from "./ProfileSelectionButton";

export default function AuthProfileSelectionModal() {
  return (
    <Card>
      <div className={styles.modalBody}>
        <HeadingText as="h2">How do you want to order?</HeadingText>
        <BodyText
          className={styles.modalDescription}
          color="body-1"
          fontSize="1.6rem"
        >
          Sign in as your Own Account or Company
        </BodyText>
        <div className={styles.profileOptions}>
          <ProfileSelectionButton />
        </div>
      </div>
    </Card>
  );
}
